import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgArrowUpIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M27.106 17.118A3.2 3.2 0 0 1 29.536 16h4.927a3.2 3.2 0 0 1 2.43 1.117l9.121 10.642-2.43 2.082-9.12-10.641h-.865V48h-3.2V19.2h-.864l-9.121 10.641-2.43-2.082z"
    />
  </svg>
)
export default SvgArrowUpIcon
